import React, { useState } from 'react';
import logoFooter from '../assets/logoFooter.png';
import footerIcon from '../assets/footerIcon.png';
import footerMobile1 from '../assets/footerMobile1.png';
import footerMobile2 from '../assets/footerMobile2.png';

const Footer = () => {
  return (
    <>
    <footer className="bg-[#303442] text-white py-6 md:block hidden">
      <div className="container mx-auto flex flex-col items-center">
        {/* Logo */}
        <img src={logoFooter} alt="Logo Footer" className="h-30 md:h-20 w-auto mb-10" />

        {/* Nội dung Footer */}
        <div className="flex gap-6">
          <a href="#" className="hover:underline text-[#868DA5]">Giới thiệu về XX88</a>
          <div className="text-[#868DA5]">|</div>
          <a href="#" className="hover:underline text-[#868DA5]">Điều khoản & điều kiện</a>
          <div className="text-[#868DA5]">|</div>
          <a href="#" className="hover:underline text-[#868DA5]">Chơi có trách nhiệm</a>
          <div className="text-[#868DA5]">|</div>
          <a href="#" className="hover:underline text-[#868DA5]">Miễn trách nhiệm</a>
          <div className="text-[#868DA5]">|</div>
          <a href="#" className="hover:underline text-[#868DA5]">Quyền riêng tư</a>
          <div className="text-[#868DA5]">|</div>
          <a href="#" className="hover:underline text-[#868DA5]">Hướng dẫn nạp rút</a>
          <div className="text-[#868DA5]">|</div>
          <a href="#" className="hover:underline text-[#868DA5]">Câu hỏi thường gặp</a>
          <div className="text-[#868DA5]">|</div>
          <a href="#" className="hover:underline text-[#868DA5]">Liên hệ</a>
        </div>

        {/* Bản quyền */}
        <div className="mt-6 text-sm opacity-80">
        <img src={footerIcon} alt="Footer Icon" className="w-auto h-auto mb-4" />
        </div>
      </div>
    </footer>


    {/* Mobile */}
    <footer className="bg-[#303442] text-white py-6 md:hidden block">
      <div className="container mx-auto flex flex-col items-center">
        {/* Logo */}
        <img src={logoFooter} alt="Logo Footer" className="h-8 md:h-10 w-auto mb-4" />

        {/* Nội dung Footer - Mobile */}
        <div className="flex flex-col items-center space-y-2 px-3 text-[11px]">
          {/* Hàng 1 */}
          <div className="flex items-center justify-center">
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Giới thiệu về RR88</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Điều khoản & điều kiện</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Chơi có trách nhiệm</a>
          </div>

          {/* Hàng 2 */}
          <div className="flex items-center justify-center">
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Miễn trách nhiệm</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Quyền riêng tư</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Hướng dẫn nạp rút</a>
          </div>

          {/* Hàng 3 */}
          <div className="flex items-center justify-center">
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Câu hỏi thường gặp</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Liên hệ</a>
          </div>
        </div>

        {/* Bản quyền */}
        <div className="flex flex-col items-center mt-6 text-sm opacity-80">
          <img src={footerMobile1} alt="Footer Mobile 1" className="w-auto h-auto mb-4 px-2" />
          <img src={footerMobile2} alt="Footer Mobile 2" className="w-auto h-auto mb-4 px-2" />
        </div>
      </div>
    </footer>

    </>
  );
};

export default Footer;